var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2v2H4v6H2V2h8z",
    fill: "#1D2129"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2h8v2H4v6H2V2z",
    fill: "#1D2129"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2v2h6v6h2V2h-8z",
    fill: "#1D2129"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22 2h8v8h-2V4h-6V2z",
    fill: "#1D2129"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22v8h8v-2H4v-6H2z",
    fill: "#1D2129"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 22h2v6h6v2H2v-8z",
    fill: "#1D2129"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28h8v-8h-2v6h-6v2z",
    fill: "#1D2129"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22 28h8v-8h-2v6h-6v2z",
    fill: "#1D2129"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.74cb0dccfc1c06635099476897e1a4fa.svg";
export { ForwardRef as ReactComponent };